import { useState } from "react";

import { BiMessageSquareAdd } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { RiHomeSmileFill, RiMoneyDollarCircleLine } from "react-icons/ri";
import { IoGift, IoQrCode } from "react-icons/io5";
import MenuBar from "../pages/MenuBar/MenuBar";
import { useLocation, useNavigate } from "react-router";
import { loading, loadingDestroy, openMenu } from "../redux/action/action";
import { useDispatch } from "react-redux";
import { HiShare } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { isLoggedIn } from "../utils/isLoggedIn";
import { MdEventAvailable } from "react-icons/md";
import usePwaDetected from "../hook/usePwaDetected";

const iconStyle = "text-2xl";

const Footer = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`footer.${key}`);

  const [isFooterOpen, setIsFooterOpen] = useState("Home");
  const isPwa = usePwaDetected();

  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const FOOTER_LIST = [
    {
      icon: <GiHamburgerMenu className={iconStyle} />,
      text: "Menu",
    },
    {
      icon: <IoGift className={iconStyle} />,
      text: "Rewards",
      link: "casino/profile/rewards",
      auth: true,
    },
    {
      icon: (
        <div className="w-[55px] h-[55px] border-b-[#b34600] border-b-[3px] border-x-[1px] border-x-[#da5200] border-t-[#da5200] border-t-[0.5px] shadow-lg bg-main-color shadow flex items-center justify-center rounded-full absolute top-[-15px]">
          <RiHomeSmileFill
            className={`${iconStyle} text-base-white dark:text-base-white text-4xl`}
          />
        </div>
      ),
      text: "home",
      link: "casino",
    },
    {
      icon: <HiShare className={iconStyle} />,
      text: "Refer",
      link: "casino/profile/refer-code",
      auth: true,
    },
    ...(isPwa
      ? [
          {
            icon: <MdEventAvailable className={iconStyle} />,
            text: "promotion",
            link: "promotion",
          },
        ]
      : [
          {
            icon: <BiMessageSquareAdd className={iconStyle} />,
            text: "App",
            link: "app",
          },
        ]),
    // {
    //   icon: <MdEventAvailable className={iconStyle} />,
    //   text: "promotion",
    //   link: "promotion",
    // },
  ];

  return (
    <footer className="fixed bottom-0 left-0 w-full h-[72px] rounded-t-3xl bg-footer-bg !p-[16px] dark:bg-base-light-dark footer-shadow grid grid-cols-5 py-common-padding-y z-[1000]">
      {FOOTER_LIST.map((footer, index) => {
        return (
          <div
            key={index}
            className={`flex flex-col items-center justify-end gap-[5px] text-dark-gray-text dark:text-base-white`}
            onClick={() => {
              setIsFooterOpen(footer.text);
              if (footer.auth && !isLoggedIn()) {
                navigate("signin");
              } else if (footer.text === "Menu") {
                dispatch(openMenu());
              } else if (footer.text === "App") {
                navigate("app");
              } else {
                dispatch(loading());

                setTimeout(() => {
                  navigate(`/${footer.link}`);
                  dispatch(loadingDestroy());
                }, 200);
              }
            }}
          >
            {footer.icon}
            <p className="mb-0 font-medium text-sm text-overflow w-full text-center">
              {i18n(footer.text?.toLowerCase())}
            </p>
          </div>
        );
      })}
      {/* <MenuBar isMenuOpen={isFooterOpen} setIsMenuOpen={setIsFooterOpen} /> */}
    </footer>
  );
};

export default Footer;
